<ng-container *transloco="let t">
    <div class="bazis-file-inline">
        <bazis-badge
            color="danger"
            size="large"
        >
            {{ extension() }}
        </bazis-badge>

        @if (srcFile()) {
            <span class="bazis-list bazis-list_short-info">
                <span class="bazis-item">
                    <bazis-link
                        class="bazis-file-inline__file"
                        borderStyle="none"
                        [href]="hasLink() ? srcFile() : undefined"
                        [target]="hasLink() ? '_blank' : '_self'"
                        [title]="t(fileNameKey(), fileNameParams()) || nameFile()"
                    >
                        {{ fileNameKey() ? t(fileNameKey(), fileNameParams()) : nameFile() }}
                    </bazis-link>
                </span>

                @if (showFileSize()) {
                    <span class="bazis-item">
                        <span>
                            {{ sizeFile() | fileSize }}
                        </span>

                        @if (tooltipKey()) {
                            <span #tooltipTarget>
                                &nbsp;
                                <bazis-icon
                                    name="interrogation"
                                    size="compact"
                                ></bazis-icon>
                                <bazis-tooltip
                                    [reference]="tooltipTarget"
                                    placement="top-end"
                                    [isStatic]="false"
                                    [offset]="[8, 4]"
                                    class="bh-popper-z-index"
                                >
                                    {{ t(tooltipKey(), tooltipParams()) }}
                                </bazis-tooltip>
                            </span>
                        }
                    </span>
                }
            </span>
        }
    </div>
</ng-container>
